import {
    infiniteHits
} from "instantsearch.js/es/widgets";

import {
    getCard
} from '../helpers/helpers';

export default function (el, Alpine) {
    Alpine.bind(el, {
        'x-init'() {
            this.$data.__search.addWidgets([
                infiniteHits({
                    container: el,
                    templates: {
                        item(item, { html }) {
                            return getCard(item, html);
                        },
                        showMoreText(data, { html }) {
                            return html`load more`;
                        },
                    },
                    cssClasses: {
						root: 'container',
						loadMore: 'button',
						disabledLoadMore: '!hidden',
					},
                })
            ])
        }
    })
}